import { Observable } from "rxjs";
import { LocationModel } from "../models/thirdparty/location.model";
import { IpEntity } from "../../data/repositories/thirdparty/entities/ip.entity";


export abstract class ThirdPartyRepository {
    abstract getIp(): Observable<IpEntity>;
    abstract getIpLocation(params: {ip: string}): Observable<LocationModel>;
}